export default __webpack_public_path__ + "static/instagram-round-line-icon-white-47d26a34ee2701ae38e89ec1c37ed77e.png";